import * as changePassword from "../redux/modules/changePassword";
import * as core from "../redux/modules/core";

export const changePasswordController = {
  /**
   * パスワード変更要求の状態を確認する
   */
  checkChangePasswordRequired: () => (
    dispatch,
    getState,
    { request, storage }
  ) => {
    request({
      url: "/api/v1/action_point/me/",
      headers: {
        Authorization: storage.get("reward-app-token"),
      },
    })
      .then((result) => {
        // パスワード変更要求がない場合は、ホーム画面に戻す
        if (result.data && !result.data.changePasswordRequired) {
          dispatch(changePassword.actions.backToHome());
        }
      })
      .catch((error) => {
        if (error.code === "401") {
          dispatch(core.actions.happenedApiUnauthorized());
        }
      });
  },
  /**
   * パスワード更新
   */
  updatePassword: (password, passwordConfirmation) => (
    dispatch,
    getState,
    { request, storage }
  ) => {
    dispatch(changePassword.actions.requestUpdatePasswordApi());

    request({
      method: "POST",
      url: "/api/v1/action_point/password/change_for_first_time/",
      headers: {
        Authorization: storage.get("reward-app-token"),
      },
      data: {
        password: password,
        password_confirmation: passwordConfirmation,
      },
    })
      .then((result) => {
        dispatch(changePassword.actions.succeededUpdatePasswordApi());
      })
      .catch((error) => {
        if (error.code === "401") {
          dispatch(core.actions.happenedApiUnauthorized());
        } else if (error.code === "400") {
          const data = error.response.data;
          if (data.error && data.error.code === "record-invalid") {
            dispatch(changePassword.actions.errorMessage(data.error));
          }
        }
      });
  },
};
